<template>
    <div class="w-100 min-vh-100 background-cover" :style="bgStyle" :class="{ 'bg-light': !background }">

        <div class="container-fluid">
            <div class="py-5 px-0 px-sm-3">
                <div class="row">
                    <div class="col-6">
                        <a href="#" @click.prevent="clickOnLogo" :class="{ 'pointer-events-none': !clickableLogo }" v-if="!hideLogo"><Logo :color="background ? '#FFFFFF' : null" width="30" logomark></Logo></a>
                    </div>
                    <div class="col-6 text-end">
                        <SelectLang v-if="$i18n.availableLocales.length > 1" @setLanguage="setLanguage" position="right" />
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="row">
                <div :class="background ? 'col-12 col-md-6' : 'col-xl-6 offset-xl-3'">
                    <div class="bg-white p-5 fancy-border-bottom mb-5">
                        <h4 class="mb-4" v-if="title">{{ title }}</h4>
                        <slot />
                    </div>
                </div>
                <div class="col-12 col-md-6" v-if="background">
                    <div class="login-title fw-bolder text-white mt-2 d-none d-md-block" style="width: 100px;">
                        {{ background.text }}
                    </div>
                </div>
            </div>
            <footer class="text-xxs text-center text-muted pb-4">
                <ul class="list-inline">
                    <li class="list-inline-item mx-2">© Hexeko {{ moment().format('YYYY') }}</li>
                    <li class="list-inline-item mx-2"><a href="https://hexeko.com/contact" class="text-muted" target="_blank">{{ $t('transactional.contact') }}</a></li>
                    <li class="list-inline-item mx-2"><a href="https://hexeko.com/terms" class="text-muted" target="_blank">{{ $t('transactional.terms') }}</a> & <a href="https://hexeko.com/privacy-policy" class="text-muted">{{ $t('transactional.privacy') }}</a></li>
                </ul>
            </footer>
        </div>


    </div>
</template>

<script>
    import Logo from '../Logo'
    import SelectLang from '../SelectLang'
    import moment from 'moment'

    export default {
        props: {
            backgrounds: {
                type: Array,
                required: false
            },
            title: String,
            clickableLogo: Boolean,
            loading: Boolean,
            hideLogo: Boolean
        },
        components: {
            Logo,
            SelectLang,
        },
        data() {
            return {
                moment: moment
            }
        },
        methods: {
            setLanguage(lang) {
                this.$emit('setLanguage', lang)
            },
            clickOnLogo() {
                this.$emit('clickOnLogo')
            }
        },
        computed: {
            bgStyle: function() {
                return this.background ? {
                    'background-image': "url('" + this.background.image + "')"
                } : {}
            },
            background: function() {
                return Array.isArray(this.backgrounds) && this.backgrounds.length > 0 ? this.backgrounds[0] : null
            }
        }
    }
</script>
